import { render, staticRenderFns } from "./Soc.vue?vue&type=template&id=48055f3b&scoped=true&"
import script from "./Soc.vue?vue&type=script&lang=js&"
export * from "./Soc.vue?vue&type=script&lang=js&"
import style0 from "./Soc.vue?vue&type=style&index=0&id=48055f3b&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48055f3b",
  null
  
)

export default component.exports